import React, {useEffect, useState} from 'react';
import { exclusiveCompanyCheck, signCheck} from "../../../../api";
import RegisterComponent from "../component/RegisterComponent";
import Layout from "../../../../containers/main/Layout";


function RegisterPage() {


    const [CheckCompany, setCheckCompany] = useState('')
    const [srcAddress,setSrcAddress] =useState('')



    useEffect(() => {
        exclusiveCompanyCheck()
            .then((res) => {
                //alert(res.data)
                if (res.data === 'lghello') {
                    setSrcAddress("../../../../../images/lghello.png")
                    setCheckCompany('LG HelloVision')

                }else if(res.data === 'Samsung S1'){
                    setSrcAddress("../../../../../images/s1.png")
                    setCheckCompany('Samsung S1')

                }else if(res.data === 'lguplus'){
                    setSrcAddress("../../../../../images/lguplus.png")
                    setCheckCompany('LG U+')

                }else if(res.data === 'raemian'){
                    setSrcAddress("../../../../../images/raemian.png")
                    setCheckCompany('RAEMIAN')

                }else if(res.data === 'THE WAVE'){
                    setSrcAddress("../../../../../images/the_wave.png")
                    setCheckCompany('THE WAVE')

                }else if(res.data === 'ETCETRA'){
                    setSrcAddress("../../../../../images/etcetra.png")
                    setCheckCompany('ETCETRA')

                }else if(res.data === 'Samsung C&T'){
                    setSrcAddress("../../../../../images/samsung_mulsan.png")
                    setCheckCompany('Samsung C&T')
                }else if(res.data === 'Coway'){
                    setSrcAddress("../../../../../images/coway.png")
                    setCheckCompany('Coway')
                }else if(res.data === 'blaubit'){
                    //블라우비트
                    setSrcAddress("../../../../../images/blaubit.png")
                    setCheckCompany('Blaubit')
                }else if(res.data === 'sunil'){
                    setSrcAddress("../../../../../images/sunil.png")
                    setCheckCompany('Sunil')
                }
                else{
                    setSrcAddress('')
                    setCheckCompany('')
                }
            })
    }, [])


    //로그인 체크

    const [isLogin, setIsLogin]=useState(false)
    const [user,setUser]=useState({})

    useEffect(() => {
        try{
            signCheck()
                .then((res)=>{
                    if(res.status === 200){
                        setIsLogin(true);
                        setUser(res.data)
                    }
                })
                .catch((err)=>{
                })

        }catch (err){
        }
    }, [])



    return (
        <>
            <Layout>
            {isLogin ? (
                window.location.replace('/')
                ):(
                    <RegisterComponent CheckCompany={CheckCompany} srcAddress={srcAddress}/>

                )}
            </Layout>
        </>
    )
}

export default RegisterPage;
